
import {
  createSelector,
} from 'reselect';
import {
  getResourceMappedList,
} from './resources';
import {
  alphSortByName,
} from './utils';

export const getPersonalWorkouts = userId => createSelector(
  [
    getResourceMappedList('personalWorkouts', userId),
  ],
  workouts => workouts
    .sort(alphSortByName)
    .map(workout => ({
      value: workout.id,
      label: workout.name,
    })),
);
